module.exports = __webpack_public_path__ + "img/open.17272dce.svg";